(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["B2MWebSDK"] = factory();
	else
		root["B2MWebSDK"] = factory();
})(this, () => {
return 